"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _awsAmplify = require("aws-amplify");
var _reactRedux = require("react-redux");
var _Picture = _interopRequireDefault(require("./Picture"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class RelationPicture extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      fetching: false,
      fetched: true
    });
    _defineProperty(this, "handleSubmit", data => {
      const {
        row,
        value,
        schema,
        dispatch
      } = this.props;
      this.setState({
        fetching: true,
        fetched: false
      });
      _awsAmplify.Auth.currentSession().then(res => {
        if (value && value.Id) {
          // Switch picture

          return dispatch(schema.update(value.Id, {
            Data: data
          }, res.idToken.jwtToken)).then(() => this.setState({
            fetching: false,
            fetched: true,
            data: null,
            file: null
          })).catch(() => this.setState({
            fetching: false,
            fetched: false,
            data: null,
            file: null
          }));
        } else {
          // Set new picture

          switch (schema.entity.local) {
            case 'User':
              return dispatch(schema.add({
                Data: data,
                UserId: row.Id
              }, res.idToken.jwtToken)).then(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              })).catch(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              }));
            case 'Language':
              return dispatch(schema.add({
                Data: data,
                LanguageId: row.Id
              }, res.idToken.jwtToken)).then(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              })).catch(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              }));
            case 'Category':
              return dispatch(schema.add({
                Data: data,
                CategoryId: row.Id
              }, res.idToken.jwtToken)).then(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              })).catch(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              }));
            case 'Showroom':
              return dispatch(schema.add({
                Data: data,
                ShowroomId: row.Id
              }, res.idToken.jwtToken)).then(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              })).catch(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              }));
            case 'Product':
              return dispatch(schema.add({
                Data: data,
                ProductId: row.Id
              }, res.idToken.jwtToken)).then(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              })).catch(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              }));
            case 'ContentFile':
              return dispatch(schema.add({
                Data: data,
                ContentFileId: row.Id
              }, res.idToken.jwtToken)).then(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              })).catch(() => this.setState({
                fetching: false,
                fetched: true,
                data: null,
                file: null
              }));
            default:
              console.log(`Entity ${schema.entity.local} not found`);
              return false;
          }
        }
      }).catch(err => console.dir(err));
    });
  }
  render() {
    const {
      schema,
      value,
      onChange,
      dispatch,
      row
    } = this.props;
    const {
      fetching,
      fetched
    } = this.state;
    let localEntity = schema.entity.local;
    return /*#__PURE__*/_react.default.createElement(_Picture.default, {
      value: value ? value.Data : null,
      onChange: onChange ? data => onChange({
        Data: data
      }) : null,
      onSubmit: this.handleSubmit,
      onDrop: () => dispatch(schema.drop(value.Id)),
      fetching: fetching,
      fetched: fetched,
      localEntity: localEntity,
      schema: schema,
      row: row
    });
  }
}
var _default = exports.default = (0, _reactRedux.connect)(null, null)(RelationPicture);
module.exports = exports.default;